import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { selectCompanyProduct } from '../../selectors';
import { selectConfig, selectWorks } from '../../../Api/selectors';
import { BaseComponent } from '../../../../components/BaseComponent';
import {
  REQUEST_ADD_COMPANY_PRODUCT_CUSTOMIZATION,
  REQUEST_COMPANY_PRODUCT,
  REQUEST_UPDATE_COMPANY_PRODUCT_CUSTOMIZATION,
} from '../../constants';
import { addCompanyProductCustomization, fetchCompanyProduct, updateCompanyProductCustomization } from '../../actions';
import { Loader } from '../../../../components/Loader';
import { PageHeader } from '../../../../components/PageHeader';
import { ChevronRight } from '../../../../components/Icon';
import { Content } from '../../../../components/Content';
import { HBox, VBox } from '../../../../components/Box';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Form';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import { getLedgers, getVatCodes } from '../../../Invoices/actions';
import { REQUEST_LEDGERS, REQUEST_VAT_CODES } from '../../../Invoices/constants';
import { selectLedgers, selectVatCodes } from '../../../Invoices/selectors';
import { CompanyProductCustomizationsTable } from './companyProductCustomizationsTable';
import styles from './CompanyProductDetails.module.css';

const Container = styled.div`
  .nav-link {
    cursor: pointer;
  }
  .nav-link.active {
    color: blue;
  }

  .col {
    width: 100%;
  }
  .col-main {
    padding-right: 48px;
  }

  .basic-multi-select {
    width: 100%;
  }

  .formField {
    margin-bottom: 12px;
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .field-block {
    width: 50%;
  }
  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin-right: 6px;
    }
    .col {
      @media (max-width: 768px) {
        width: 100%;
        min-width: 200px;
      }
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

export class CompanyProductDetailsComp extends BaseComponent {
  componentDidMount() {
    this.props.fetch();
    this.props.getVatCodes();
    this.props.getLedgers();
  }

  get product() {
    return this.props.product;
  }

  get statusOption() {
    return ['0', '1', '2'].map(p => {
      const lbl = this.lbl(`product.column.status.${p.toLowerCase()}`);
      return { value: p, label: lbl };
    });
  }

  get vatCodeIn() {
    return this.props.vatCodes.find(item => item.code === this.product.vatIn);
  }

  get vatCodeOut() {
    return this.props.vatCodes.find(item => item.code === this.product.vatOut);
  }

  getVatCodeLabel(vatCode) {
    return vatCode ? `${vatCode.code} : ${vatCode.description}` : 'No vat code';
  }

  get ledgerIn() {
    return this.props.ledgers.find(item => item.ledgerNumber === this.product.ledgerIn);
  }

  get ledgerOut() {
    return this.props.ledgers.find(item => item.ledgerNumber === this.product.ledgerOut);
  }

  getLedgerLabel(ledger) {
    return ledger ? `${ledger.ledgerNumber} : ${ledger.description}` : 'No ledger';
  }

  render() {
    if (this.props.work || !this.product) return <Loader small />;

    return (
      <Container>
        <PageHeader
          title={<>{this.lbl('companyProduct.customization.title')}</>}
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('company.overview.title')}
              <ChevronRight />
              {this.props.company_id}
            </>
          }
        ></PageHeader>

        <div className="info-card">
          <Content>
            <Wrapper>
              <VBox left className="col col-main">
                <HBox left className="field-block">
                  <div className={styles.inputContainer}>
                    <label className="form-label">{this.lbl('product.create.name')}</label>
                    <input name="name" className="form-control" value={this.product.name} disabled />
                  </div>
                </HBox>
                <HBox className="field-block">
                  <div className={styles.inputContainer}>
                    <label className="form-label">{this.lbl('product.create.description')}</label>
                    <textarea
                      style={{
                        width: '100%',
                      }}
                      className="form-control"
                      name="description"
                      value={this.product.description}
                      disabled
                    />
                  </div>
                </HBox>
                <HBox className="field-block">
                  <FormField label={this.lbl('product.create.status')}>
                    <SearchSelect
                      minWidth="100%"
                      options={this.statusOption}
                      value={this.product.status && { label: this.lbl(`product.column.status.${this.product.status}`) }}
                      disabled
                    />
                  </FormField>
                </HBox>
                <HBox gap="16px" style={{ marginTop: '24px' }}>
                  <VBox left>
                    <HBox>
                      <div className={styles.inputContainer}>
                        <label className="form-label">{this.lbl('product.create.vat_in')}</label>
                        <input className="form-control" value={this.getVatCodeLabel(this.vatCodeIn)} disabled />
                      </div>
                    </HBox>

                    <HBox>
                      <div className={styles.inputContainer}>
                        <label className="form-label">{this.lbl('product.create.vat_out')}</label>
                        <input className="form-control" value={this.getVatCodeLabel(this.vatCodeOut)} disabled />
                      </div>
                    </HBox>
                  </VBox>
                  <VBox left>
                    <HBox>
                      <div className={styles.inputContainer}>
                        <label className="form-label">{this.lbl('product.create.ledger_in')}</label>
                        <input className="form-control" value={this.getLedgerLabel(this.ledgerIn)} disabled />
                      </div>
                    </HBox>
                    <HBox>
                      <div className={styles.inputContainer}>
                        <label className="form-label">{this.lbl('product.create.ledger_out')}</label>
                        <input className="form-control" value={this.getLedgerLabel(this.ledgerOut)} disabled />
                      </div>
                    </HBox>
                  </VBox>
                </HBox>
                <CompanyProductCustomizationsTable
                  product={this.product}
                  onAdd={this.props.add.bind(this)}
                  onUpdate={this.props.update.bind(this)}
                />
              </VBox>
              <VBox className="col col-main"></VBox>
            </Wrapper>
          </Content>
        </div>
      </Container>
    );
  }
}

CompanyProductDetailsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    product: selectCompanyProduct(),
    work: selectWorks([
      REQUEST_COMPANY_PRODUCT,
      REQUEST_VAT_CODES,
      REQUEST_LEDGERS,
      REQUEST_ADD_COMPANY_PRODUCT_CUSTOMIZATION,
      REQUEST_UPDATE_COMPANY_PRODUCT_CUSTOMIZATION,
    ]),
    vatCodes: selectVatCodes(),
    ledgers: selectLedgers(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchCompanyProduct(ownProps.companyId, ownProps.productId));
    },
    add: (dto, callback) => {
      dto.purchasePriceExclVat = dto.purchasePriceExclVat ? +dto.purchasePriceExclVat : dto.purchasePriceExclVat;
      dto.salesPriceExclVat = dto.salesPriceExclVat ? +dto.salesPriceExclVat : dto.salesPriceExclVat;
      dispatch(addCompanyProductCustomization(ownProps.companyId, ownProps.productId, dto, {}, callback));
    },
    update: (customId, dto, callback) => {
      dto.purchasePriceExclVat = dto.purchasePriceExclVat ? +dto.purchasePriceExclVat : dto.purchasePriceExclVat;
      dto.salesPriceExclVat = dto.salesPriceExclVat ? +dto.salesPriceExclVat : dto.salesPriceExclVat;
      dispatch(updateCompanyProductCustomization(ownProps.companyId, ownProps.productId, customId, dto, {}, callback));
    },
    getVatCodes() {
      dispatch(getVatCodes());
    },
    getLedgers() {
      dispatch(getLedgers());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyProductDetails = compose(withConnect, withRouter)(CompanyProductDetailsComp);
